<template>
    <div
        :style="$_getStyle"
        class="shadowSmall advanced-search-panel d-flex flex-column"
        :class="getObjectDetailClass"
        advanced-search-panel
        ref="advancedSearchPanel"
    >
        <!-- Header -->
        <div class="panel-header modeless">
            <h3 class="panel-header-title crop modeless">
                {{ $t('advancedSearchTitle') }}
            </h3>
            <!-- Close icon -->
            <icon-close
                id="panel-search-close"
                @close="$_forceClosePanel()"
                iconColor=""
                class="d-inline-block float-right"
            >
            </icon-close>
        </div>
        <!-- Content -->
        <advanced-search
            @pinPanel="pinPanel = $event"
            :filter-object="filterObject"
            @openStufDetails="$emit('openStufDetails', $event)"
        />
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';

    import {
        INTERFACE_PANEL_TRIGGERS,
        MENUBAR_HEIGHT
    } from '../../../../constants';

    import IconClose from '../../../IconClose.vue';
    import AdvancedSearch from '../../search';

    export default {
        name: 'advanced-search-panel',
        components: { 'icon-close': IconClose, 'advanced-search': AdvancedSearch },

        props: {},

        data() {
            return {
                panelTrigger: INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH,
                selectedLayer: null,
                pinPanel: false
            };
        },

        mounted() {
            const width = this.$refs.advancedSearchPanel.scrollWidth;
            const height = this.$refs.advancedSearchPanel.clientHeight;
            this.$store.commit(
                'SET_HEIGHT_AND_WIDTH_MENU_ADVANCED_SEARCH',
                { height, width }
            );
        },
        created() {
            window.addEventListener('resize', this.onResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize);
        },
        computed: {
            ...mapState(['uiElements', 'context']),
            ...mapGetters(['getDetailInformationPanelHeight']),
            advancedSearchPanel: function () {
                return this.uiElements[this.panelTrigger];
            },
            getObjectDetailClass() {
                return { show: this.pinPanel || this.advancedSearchPanel.visible };
            },
            filterObject() {
                return this.advancedSearchPanel.components?.filter;
            },
            $_getStyle() {
                const resize = this.advancedSearchPanel.resize;
                return resize
                    ? `max-height: calc(100% - ${MENUBAR_HEIGHT}px - ${this.getDetailInformationPanelHeight}px - 10px)`
                    : null;
            }
        },

        methods: {
            ...mapActions(['togglePanel']),
            $_forceClosePanel() {
                this.pinPanel = false;
                this.togglePanel({ panelName: this.panelTrigger, visible: false });
            },
            onResize() {
                const width = this.$refs.advancedSearchPanel.scrollWidth;
                const height = this.$refs.advancedSearchPanel.clientHeight;
                this.$store.commit(
                    'SET_HEIGHT_AND_WIDTH_MENU_ADVANCED_SEARCH',
                    { height, width }
                );
            }
        }
    };
</script>

<style scoped lang="scss">
.advanced-search-panel {
    @include z-index(left-panel);
    position: fixed;
    top: var(--paneltop);
    right: 100%;
    bottom: 0;
    left: -470px;
    width: $default-panel-width;
    max-width: 100vw;
    background-color: #fff;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    display: flex !important;
    flex-direction: column;
    &.show {
        left: 0;
        .web-map & {
            @include margin-left-navbar;
            max-height: calc(100% - $menu-bar-height - 10px);
        }
    }
}
</style>
